export const hasUamAdminAccess = (roles = []) =>
  Array.isArray(roles) && roles.includes("UAM_ADMIN");